import { DataTable } from 'primereact/datatable';
import { useEffect, useRef, useState } from 'react';
import {
    crearUbicacionSimple,
    modificarUbicacionSimple,
    recuperaSimpleUbicacion
} from '../../services/Siniestro/SiniestroService';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import DibujadorDeCerca from './DibujadorDeCerca';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';

const AdminZonas = () => {
    const [cargando, setCargando] = useState(false);
    const [lstZonas, setLstZonas] = useState([]);
    const [visibleMapa, setVisibleMapa] = useState(false);
    const [cambioZona, setCambioZona] = useState(false);
    const [cercaInicial, setCercaInicial] = useState([]);
    const [soloConsulta, setSoloConsulta] = useState(false);
    const [zona, setZona] = useState({});

    const addZonaToast = useRef();

    useEffect(() => {
        const obtieneZonasUbicacion = async () => {
            const CODE_TIPOZONA_UBICACION = 'UBI-0000-0000-0005';
            try {
                setCargando(true);
                const data = await recuperaSimpleUbicacion(CODE_TIPOZONA_UBICACION);
                //console.log ('ZONAS DATA..: ', data)
                setLstZonas(data);
            } catch (error) {
                console.error('ERROR: Al obtener Ubicaciones de Zonas');
            } finally {
                setCargando(false);
            }
        };
        obtieneZonasUbicacion();
    }, [cambioZona]);

    const actionBody = (rowData) => {
        return (
            <div className="flex gap-2 justify-content-center">
                <Button
                    icon="pi pi-eye"
                    className="p-button-rounded p-button-warning p-button-text"
                    style={{ width: '2rem', height: '2rem', fontSize: '0.8rem' }}
                    tooltip="Ver Zona"
                    onClick={() => verMapaVer(rowData)}
                />
            </div>
        );
    };

    const verMapaNuevo = () => {
        setCercaInicial('[]');
        setSoloConsulta(false);
        setZona({});
        setVisibleMapa(true);
    };

    const verMapaVer = (rowData) => {
        //console.log('ESTOS SON LOS DATOS.... : ', rowData);
        let coordenadasRaw = rowData.area.replace('POLYGON ((', '').replace('))', '');

        let puntosArray = coordenadasRaw.split(', ').map((par) => {
            const [lat, lng] = par.trim().split(' ');
            return { lat: parseFloat(lat), lng: parseFloat(lng) };
        });
        puntosArray.pop();

        const propParaComponente = JSON.stringify(puntosArray);
        setCercaInicial(propParaComponente);
        //setSoloConsulta(true)
        setZona(rowData);
        setVisibleMapa(true);
    };

    const ocultarMapa = () => {
        setVisibleMapa(false);
    };

    const confirmaMapa = async (retorno) => {
        setVisibleMapa(false);
        try {
            setCargando(true);
            const objPost = {
                nombre: retorno.nombre,
                codigo: retorno.codigo,
                latitud: 0,
                longitud: 0,
                area: retorno.geocerca,
                atributos: ''
            };
            const CODE_TIPOUBICACION_ZONA = 'UBI-0000-0000-0005';
            let data;
            if (zona?.ubicacionId) {
                objPost['ubicacionId'] = zona?.ubicacionId;
                objPost['codigo'] = zona?.codigo;
                data = await modificarUbicacionSimple(objPost, CODE_TIPOUBICACION_ZONA);
            } else {
                objPost['codigo'] = crypto.randomUUID()
                data = await crearUbicacionSimple(objPost, CODE_TIPOUBICACION_ZONA);
            }
            if (data.ubicacionId) {
                addZonaToast.current.show({ severity: 'success', summary: 'Exito', detail: 'Se ha registrado la Zona' });
                setCambioZona((prev) => !prev);
            }
        } catch (error) {
            addZonaToast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: 'ERROR al crear Zona en Ubicacion'
            });
        } finally {
            setCargando(false);
        }
    };

    // filtros
    const [filtros, setFiltros] = useState({
        global: { value: null, matchMode: 'contains' },
        nombre: { value: null, matchMode: 'contains' }
    });
    // Estado para los valores visuales de los filtros
    const [valoresFiltros, setValoresFiltros] = useState({
        nombre: '',
        global: ''
    });

    const textoFilterTemplate = (options, field) => {
        return (
            <InputText
                value={valoresFiltros[field]}
                onChange={(e) => {
                    const nuevoValor = e.target.value;
                    // Actualizamos el valor visual
                    setValoresFiltros((prev) => ({ ...prev, [field]: nuevoValor }));

                    // Actualizamos el filtro real después de un pequeño delay
                    setTimeout(() => {
                        const newFilters = { ...filtros };
                        newFilters[field].value = nuevoValor;
                        setFiltros(newFilters);
                        options.filterApplyCallback(nuevoValor);
                    }, 10);
                }}
                placeholder={`Filtro ${field}`}
                className="w-full"
            />
        );
    };

    return (
        <div className="card">
            <Toast ref={addZonaToast} />
            <Dialog
                visible={visibleMapa}
                onHide={() => setVisibleMapa(false)}
                filters={filtros}
                filterDisplay="row"
                style={{ width: '60vw' }}
            >
                <DibujadorDeCerca
                    cercaInicial={cercaInicial}
                    onCancelar={ocultarMapa}
                    onConfirmar={confirmaMapa}
                    soloConsulta={soloConsulta}
                    datZona={zona}
                />
            </Dialog>
            <div className="formgrid grid p-fluid mb-3">
                <div className="field col-12 md:col-12">
                    <DataTable
                        value={lstZonas}
                        showGridlines
                        size="small"
                        paginator
                        rows={5}
                        rowsPerPageOptions={[5, 10, 25]}
                        responsiveLayout="scroll"
                        emptyMessage="No hay Zonas registradas"
                        loading={cargando}
                        loadingIcon="pi pi-spin pi-cog"
                        filters={filtros}
                        filterDisplay="row"
                    >
                        <Column header="Nombre" field="nombre" filter
                            filterPlaceholder="Filtro Puesto"
                            filterElement={(options) => textoFilterTemplate(options, 'nombre')}/>
                        <Column header="Acciones" body={actionBody} />
                    </DataTable>
                </div>
                <div className="field col-12 md:col-8">
                    <label style={{ visibility: 'hidden' }}>Texto oculto</label>
                </div>
                <div className="field col-12 md:col-4">
                    <Button label="Adicion" icon="pi pi-plus" onClick={verMapaNuevo} />
                </div>
            </div>
        </div>
    );
};

export default AdminZonas;
